import { isValid, parse } from 'date-fns';

const validateDate = (date, pattern) => {
  const parsedDate = parse(date, pattern, new Date());
  return isValid(parsedDate);
};

export default validateDate;
